import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import ApplicationLayout from '../../layouts/ApplicationLayout';
import HttpAPICall from '../../services/HttpAPICall';
import { ORG_API_BASE_URL_2 } from '../../services/TapApiUrls';
import { useSelector } from 'react-redux';
import Loader from '../../components/ui/Loader/Loader';
import Status from '../../components/ui/Status';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import TapIcon from '../../services/TapIcon';
import Ax from '../../components/hoc/Ax';
import MySites from './MySites';
import { Modal } from 'bootstrap';
import ChangePasswordModal from './ChangePasswordModal';
import Change2FAModal from './Change2FAModal';

const MyProfile = () => {
    const changePasswordModalRef = useRef(null);
    const change2FAModalRef = useRef(null);

    const [userDetailData, setUserDetailData] = useState(null);
    const [view_loading, setView_loading] = useState(false);
    
    const userDetailUrl = ORG_API_BASE_URL_2 + '/user/profile/detail';
    const accessToken = useSelector(state => state.auth.access_token);

    useEffect(() => {
        changePasswordModalRef.current = new Modal(document.getElementById('changePasswordModal'), { keyboard: false, backdrop: false });
        change2FAModalRef.current = new Modal(document.getElementById('change2FAModal'), { keyboard: false, backdrop: false });
        getUserDetails();
    }, []);

    const getUserDetails = (id) => {
        setView_loading(true);
        HttpAPICall.withAthorization('GET', userDetailUrl, accessToken, { need_site_ids: 'Y' }, {}, (resp) => {
            let respData = resp.data;
            setUserDetailData(respData.data);
        }).then(() => setView_loading(false));
    };

    const changePasswordModalInit = () => {
        if (changePasswordModalRef.current) {
            changePasswordModalRef.current.show();
        }
    };

    const handleTwoFactorAuth = () => {
        if (change2FAModalRef.current) {
            change2FAModalRef.current.show();
        }
    };

    const userViewDetailsJsx = () => {
        let detail = userDetailData;
        return (
            <section className="page_containt " style={{ top: "-2px" }}>
                <div className=" bg-white">
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button className="nav-link active" id="details-tab" data-bs-toggle="tab" data-bs-target="#details"
                                type="button" role="tab" aria-controls="details" aria-selected="true">Details
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link " id="linking-tab" data-bs-toggle="tab" data-bs-target="#linking"
                                type="button" role="tab" aria-controls="linking" aria-selected="true">My Sites
                            </button>
                        </li>
                    </ul>
                    <div className="tab-content" id="myTabContent">
                        <div className="tab-pane  show active" id="details" role="tabpanel"
                            aria-labelledby="details-tab">
                                {view_loading ? <Loader />
                                    : <div className="tab_content_header pb-5">
                                        {detail ?
                                            <div className='row'>
                                            <div className='col-sm-9'>
                                                <table className="table table-hover table-bordered  table-responsive bg-white my-2 ">
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ width: "25%" }}>Name</td>
                                                            <th style={{ width: "45%" }}>{detail.full_name ? detail.full_name : "-"}</th>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: "25%" }}>Status</td>
                                                            <th>{detail.status ? <Status color={detail.status_color_code}>{detail.status_text}</Status> : "-"}</th>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: "25%" }}>Role</td>
                                                            <th>{detail.role && detail.role.role ? detail.role.role : "-"}</th>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: "25%" }}>Role visibility</td>
                                                            <th className='text-capitalize'>{detail.role && detail.role.visibility ? detail.role.visibility : "-"}</th>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: "25%" }}>Designation	</td>
                                                            <th>{detail.designation ? detail.designation : "-"}</th>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: "25%" }}>Email ID	</td>
                                                            <th>{detail.email ? detail.email : "-"}</th>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: "25%" }}>Mobile Number</td>
                                                            <th>{detail.mobile ? detail.mobile : "-"}</th>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: "25%" }}>Two Factor Authentication</td>
                                                            <th>{detail.enable_2fa === 'Y' ?
                                                                <Status color="green">Enabled</Status> :
                                                                <Status color="red">Disabled</Status>}
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: "25%" }}>Remarks</td>
                                                            <th>{detail.user_detail && detail.user_detail.remarks ? detail.user_detail.remarks : "-"}</th>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: "25%" }}>Last Logged In</td>
                                                            <th>{detail.last_login && detail.last_login.last_login_display ? detail.last_login.last_login_display : "-"}</th>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                {/* <div className="tab_content_wrapper mt-3">
                                                    <span className="content_heading">Notification Type</span>
                                                </div>
                                                <table className="table table-hover table-bordered  table-responsive bg-white my-2 ">
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ width: "25%" }}>On Ticket Creation</td>
                                                            <th style={{ width: "45%" }}>Yes</th>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: "25%" }}>On Ticket Update</td>
                                                            <th>No</th>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ width: "25%" }}>On PO Update</td>
                                                            <th>-</th>
                                                        </tr>
                                                    </tbody>
                                                </table> */}
                                            </div>
                                            <div className='col-sm-3'>
                                                <table className="table table-hover table-bordered  table-responsive bg-white my-2 ">
                                                    <tbody>
                                                        <tr>
                                                            <th className="text-center"><img src={detail?.image} className="img_fluid" alt="profile_img" style={{ height: "120px" }} /> </th>
                                                        </tr>
                                                        <tr>
                                                            <th>Name :  {detail.full_name ? detail.full_name : "-"} </th>
                                                        </tr>
                                                        <tr>
                                                            <th>Status :  {detail.status ? <Status color={detail.status_color_code}>{detail.status_text}</Status> : "-"} </th>
                                                        </tr>
                                                        <tr>
                                                            <th>2FA :  {detail.enable_2fa === 'Y' ?
                                                                <Status color="green">Enabled</Status> :
                                                                <Status color="red">Disabled</Status>}
                                                            </th>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        : null}
                                </div>}
                          
                        </div>
                        <div className="tab-pane" id="linking" role="tabpanel" aria-labelledby="linking-tab">
                            <div className="tab_content_header">
                                <MySites
                                    userDetailData={userDetailData}
                                    afterLinkingSiteSubmit={() => {
                                        getUserDetails(userDetailData?.id);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    };

    const userListjsx = () => {
        return (
            <Ax>
                <div className="page_title row m0">
                    <div className="col-12 tap_border_left">
                        <h3>Profile : {userDetailData && userDetailData.full_name ? userDetailData.full_name : "-"} </h3>
                        <div className="text-end mt15">
                            <span className="dropdown">
                                <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary">
                                    <TapIcon.imageIcon icon={TapIcon.ActionIcon} className="img-fluid" alt="item-action" />
                                </button>
                                <ul className="dropdown-menu me-5" aria-labelledby="dropdownMenuButton1">
                                    <li>
                                        <Link
                                            role="button"
                                            onClick={changePasswordModalInit}
                                            className='dropdown-item'
                                            style={{ "pointerEvents": "all" }}
                                        >   
                                            Change Password
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            role="button"
                                            onClick={handleTwoFactorAuth}
                                            className='dropdown-item'
                                            style={{ "pointerEvents": "all" }}
                                        >
                                            {userDetailData?.enable_2fa === 'Y' ? 'Disable' : 'Enable'} 2FA
                                        </Link>
                                    </li>
                                </ul>
                            </span>
                        </div>
                    </div>
                </div>
                <div className="container-fluid pl5">
                    <div className="page_containt row">
                        <div className="bg-white p-2" style={{ height: "100%" }}>
                            {view_loading ? <Loader /> : userViewDetailsJsx()}
                        </div>
                    </div>
                </div>
            </Ax>
        );
    };

    return (
        <>
            <Helmet><title>My Profile</title></Helmet>
            <ApplicationLayout>
                {userListjsx()}
                <ChangePasswordModal
                    modalRef={changePasswordModalRef}
                    userDetailData={userDetailData}
                />
                <Change2FAModal
                    modalRef={change2FAModalRef}
                    userDetailData={userDetailData}
                    onSuccess={getUserDetails}
                />
            </ApplicationLayout>
        </>
    );
};

export default MyProfile;